import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37dcf856"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 row mb-4 pb-4 border-bottom mx-0" }
const _hoisted_2 = { class: "col-lg-3 col-form-label field-label ps-0 fs-7" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "break-line" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "white-space-pre-line fs-8"
}
const _hoisted_5 = { class: "col-lg-1 d-flex align-items-center required-container" }
const _hoisted_6 = {
  key: 0,
  class: "required d-flex align-items-center justify-content-center fw-bold"
}
const _hoisted_7 = { class: "col-lg-8 pe-0" }
const _hoisted_8 = { class: "position-relative" }

import { translate } from '@/languages/i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
  label: {
    type: String,
    default: '',
  },
  labelDescribe: {
    type: String,
    default: '',
  },
  fieldRequired: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(__props.label) + " ", 1),
      _hoisted_3,
      (__props.labelDescribe)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.labelDescribe), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (__props.fieldRequired)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(translate)('CG40required')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})